import { LRUCache } from 'lru-cache';

function hashObject(obj) {
  const normalizedObj = {};
  const keys = Object.keys(obj).sort();
  for (const key of keys) {
    normalizedObj[key] = obj[key];
  }
  const str = JSON.stringify(normalizedObj);
  return str;
}

const cache = new LRUCache<string, object>({
  max: 100,
  ttl: 1000 * 60 * 5,
});

/**
 * cache request
 * @param key unique key
 * @param fetcher request function (return Promise)
 * @param ttl single cache expiration time (ms)
 */
export function requestWithCache<T extends (...args: any[]) => Promise<any>>(
  keyPrefix: string,
  fetcher: T,
  ttl?: number,
) {
  return (...args: Parameters<T>): Promise<Awaited<ReturnType<T>>> => {
    const key = [keyPrefix, hashObject(args)].join('_');

    const value = cache.get(key);

    if (value) {
      return value as ReturnType<T>;
    }

    const promise = fetcher(...args);

    cache.set(key, promise, { ttl });

    promise
      .then((result) => {
        if (result && typeof result === 'object' && result.success === false) {
          cache.delete(key);
        }
        return result;
      })
      .catch(() => {
        cache.delete(key);
        // Don't re-throw: this branch is only for cache eviction.
        // The original `promise` returned to callers handles the rejection.
      });

    return promise;
  };
}

/**
 * clear all cache
 */
export function clearAllCache() {
  cache.clear();
}
